export default __webpack_public_path__ + "static/media/i39.9c308a46.jpg";